<template>
  <LifePolicyDetail></LifePolicyDetail>
</template>
<script type="text/javascript">
import { LifePolicyDetail } from '../components'
export default {
  name: 'lifePolicyDetailContainer',
  created() {

  },
  components: {
    LifePolicyDetail
  }

}

</script>



// WEBPACK FOOTER //
// src/Osm/LifePolicy/containers/LifePolicyDetailContainer.vue